import { render, staticRenderFns } from "./aiChart.vue?vue&type=template&id=c60c0a6a&scoped=true"
import script from "./aiChart.vue?vue&type=script&lang=js"
export * from "./aiChart.vue?vue&type=script&lang=js"
import style0 from "./aiChart.vue?vue&type=style&index=0&id=c60c0a6a&prod&lang=less&scoped=true"
import style1 from "./aiChart.vue?vue&type=style&index=1&id=c60c0a6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60c0a6a",
  null
  
)

export default component.exports